// Plain (non-'use client') module so Server Components — e.g. the
// /entries/[tab] route — can import ENTRIES_SLUGS without pulling
// in BackofficeApp.tsx's client bundle (recharts, supertokens-auth-react, …).
// Importing a value export from a 'use client' file into a Server Component
// breaks Next's module graph and causes an endless dev-server rebuild loop.
export const ENTRIES_SLUGS: Record<string, string> = {
  'entries-cases': 'cases',
  'entries-casos': 'casos',
  'entries-unified': 'unified',
  'entries-campaigns': 'campaigns',
  'entries-domains': 'domain-candidates',
  'entries-plataformas-manage': 'plataformas',
  'entries-brand-vocabulary': 'brand-vocabulary',
  'entries-token-chain': 'token-chain',
  'entries-sources-manage': 'sources',
  'entries-tenants-manage': 'tenants',
  'entries-tenant-logs': 'tenant-logs',
  'entries-email-types': 'email-types',
  'entries-email-logs': 'email-logs',
  'entries-email-compose': 'email-compose',
  'entries-submit-entry': 'submit-entry',
  'entries-jobs': 'jobs',
  'entries-actions': 'actions',
  'entries-calls-godview': 'calls-godview',
  'entries-ui-kit': 'ui-kit',
}
